import { ref, computed } from 'vue'

export function useLocales() {
   
    const languages = ref({
        en : {
            'img': '/assets/media/flags/united-states.svg',
            'title': 'locales.en',
            'code': 'en'
        },
        fr : {
            'img': '/assets/media/flags/france.svg',
            'title': 'locales.fr',
            'code': 'fr'
        },
    })

    const locale = computed(() => i18n.global.locale.value)
    const currentLanguage = computed(() => languages.value[locale.value])

    function setLocale(code){
        i18n.global.locale.value = code
        Ls.set('locale', code)
    }
  

    return { languages, currentLanguage, setLocale }
  }